<template>
  <dropdown
    offset-y
    :close-on-content-click="false"
    max-width="130px"
    min-width="130px"
    nudge-left="45px"
    :items="items"
  >
    <slot></slot>

    <template #item="{ item }">
      <dropdown-item
        @click="handleOptionClick(item)"
        :icon="item.icon"
        :iconColor="iconColor(item.route)"
      >
        <span :class="textClass(item.route)">
          {{ item.text }}
        </span>
      </dropdown-item>
    </template>
  </dropdown>
</template>

<script>
import Dropdown from "@/components/Dropdown/Dropdown";
import DropdownItem from "./DropdownItem";

export default {
  components: {
    Dropdown,
    DropdownItem,
  },
  props: {
    options: Array,
  },
  computed: {
    items() {
      return this.options.map((e, i) => {
        e.id = i;
        return e;
      });
    },
  },
  methods: {
    isActiveRoute(name) {
      return this.$route.name === name;
    },
    textClass(route) {
      const active = this.isActiveRoute(route) ? "primary--text" : "";
      return `a-text ${active}`;
    },
    iconColor(route) {
      return this.isActiveRoute(route) ? "primary" : "secondary";
    },
    handleOptionClick(item) {
      const { route } = item;
      this.$emit("changeRoute", route);
    },
  },
};
</script>

<style scoped>
.option {
  display: flex;
  gap: 10px;
  cursor: pointer;
}
</style>